export const CATEGORIES = {
  INNOVATION: 'FILTERS_CATEGORIES_INNOVATION',
  MISCONCEPTION: 'FILTERS_CATEGORIES_MISCONCEPTION',
  STANDBY: 'FILTERS_CATEGORIES_STANDBY',
  EVENT: 'FILTERS_CATEGORIES_EVENT',
  PODCAST: 'FILTERS_CATEGORIES_PODCAST',
  WIDE_ANGLE: 'FILTERS_CATEGORIES_WIDE_ANGLE',
  LIFESPIRATION: 'FILTERS_CATEGORIES_LIFESPIRATION',
  LIGHTING: 'FILTERS_CATEGORIES_LIGHTING',
  START_UP: 'FILTERS_CATEGORIES_START_UP',
  MARKS: 'FILTERS_CATEGORIES_MARKS',
  MEETING: 'FILTERS_CATEGORIES_MEETING',
  PUBLICATION: 'FILTERS_CATEGORIES_PUBLICATION',
  PUBLICATION_DOWNLOADABLE: 'FILTERS_CATEGORIES_PUBLICATION_DOWNLOADABLE',
};
